import { render } from "./TablePostes.vue?vue&type=template&id=183fa657"
import script from "./TablePostes.vue?vue&type=script&lang=js"
export * from "./TablePostes.vue?vue&type=script&lang=js"

import "./TablePostes.vue?vue&type=style&index=0&id=183fa657&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__